import t from "react";
import { EnvironmentProvider as l } from "../../../features/common/hooks/environment/context.js";
import { Loading as i } from "../../../features/common/components/Loading/Loading.js";
import { useStyle as c } from "../../../features/dom/hooks/useStyle.js";
import { KioskLandingProvider as s, useKioskLanding as r } from "./context.js";
import { Home as u } from "./pages/Home/Home.js";
import { Service as d } from "./pages/Service/Service.js";
import { Inactive as f } from "./pages/Inactive/Inactive.js";
import { Languages as g } from "./pages/Languages/Languages.js";
import { OutOfOrder as p } from "./pages/OutOfOrder/OutOfOrder.js";
function E() {
  const {
    currentPage: n
  } = r();
  switch (n) {
    case "out-of-order":
      return /* @__PURE__ */ t.createElement(p, null);
    case "service":
      return /* @__PURE__ */ t.createElement(d, null);
    case "languages":
      return /* @__PURE__ */ t.createElement(g, null);
    case "inactive-confirmation":
      return /* @__PURE__ */ t.createElement(f, null);
    case "home":
    default:
      return /* @__PURE__ */ t.createElement(u, null);
  }
}
function k() {
  const {
    isLoading: n,
    configuration: e
  } = r(), o = (e == null ? void 0 : e.common.design.fontFamily) || "Quicksand";
  return c(`https://fonts.googleapis.com/css?family=${encodeURIComponent(o)}&display=swap`), n ? /* @__PURE__ */ t.createElement(i, null) : /* @__PURE__ */ t.createElement(
    "div",
    {
      "data-testid": "kiosk-landing",
      style: {
        height: "100%",
        overflow: "auto",
        fontFamily: o,
        backgroundColor: (e == null ? void 0 : e.common.design.colors.backgroundMain) || "#FFFFFF",
        color: (e == null ? void 0 : e.common.design.colors.text) || "#000000"
      }
    },
    /* @__PURE__ */ t.createElement(E, null)
  );
}
function R({
  kioskId: n,
  testMode: e,
  virtualKeyboard: o,
  onLoad: m,
  env: a
}) {
  return /* @__PURE__ */ t.createElement(l, { env: a }, /* @__PURE__ */ t.createElement(
    s,
    {
      kioskId: n,
      testMode: e,
      virtualKeyboard: o,
      onLoad: m
    },
    /* @__PURE__ */ t.createElement(k, null)
  ));
}
export {
  R as KioskLanding
};
//# sourceMappingURL=KioskLanding.js.map
